import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { AddStoreBrickAreaLocation } from "../../../domain/useages/brick-management/add-store-brick-area-location";
import { RemoteAddStoreBrickAreaLocation } from "../../../data/usecases/brick-management/remote-add-store-brick-area-location";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface AddStoreBrickAreaLocationInterface {
  AddStoreBrickAreaLocationState: FetchState;
  addStoreBrickAreaLocation: Function;
}

const initialStates = {
  AddStoreBrickAreaLocationState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useAddStoreBrickAreaLocationSlice: StateCreator<
  AddStoreBrickAreaLocationInterface
> = (set) => ({
  ...initialStates,
  addStoreBrickAreaLocation: async (
    payload: AddStoreBrickAreaLocation.Params
  ) => {
 const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
 const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddStoreBrickAreaLocation = new RemoteAddStoreBrickAreaLocation(
      `${BASE_URL}${Endpoints.ADD_BRICK_AREA_STORE_LOCATION}`,
      axiosHttpClient
    );
    let result = await remoteAddStoreBrickAreaLocation.add(payload);
    return result;
  },
});
